import React, { useState } from "react"
import { Box, Button } from "@material-ui/core"
import { CardElement, useStripe, useElements } from "@stripe/react-stripe-js"
import { addStripeToOrg } from "actions/organization"
import { useDispatch, useSelector } from "react-redux"
import LoaderButton from "components/LoaderButton"
import DialogsContainerDialog from "../../../../../dialogs/DialogsContainer"
import { withStyles } from "@material-ui/styles"
import styles from "./styles"
const UpdateCardInfoDialog = ({ open, close, classes }) => {
  const stripe = useStripe()
  const elements = useElements()
  const dispatch = useDispatch()
  const [working, setWorking] = useState(false)
  const org = useSelector(state => state.organization.currentOrg)

  const getStripeToken = async () => {
    if (!stripe || !elements) {
      console.log("no stripe")
      return
    }
    const cardElement = elements.getElement("card")

    // Use your card Element with other Stripe.js APIs
    const { error, source } = await stripe.createSource(cardElement)

    if (error) {
      throw error
    }
    return source.id
  }
  const submitCard = () => {
    setWorking(true)
    getStripeToken()
      .then(stripeToken => {
        return dispatch(addStripeToOrg(org.id, stripeToken))
      })
      .then(() => {
        close()
      })
      .catch(err => [console.log(err)])
      .finally(() => {
        setWorking(false)
      })
  }
  return (
    <DialogsContainerDialog
      open={open}
      handleClose={close}
      disableBackdropClick={org && org.bad_stripe}
      title="Edit Card Info"
      content={
        <Box className={classes.editCardContainer}>
          {org && org.bad_stripe
            ? "Your card info is invalid, please enter a new card."
            : "Add a new card to be used instead of your old card."}
          <div style={{ width: "450px", marginTop: "16px" }}>
            <CardElement />
          </div>
        </Box>
      }
      buttons={
        <Box>
          <Button
            variant="text"
            className={classes.cancelButton}
            onClick={close}
          >
            Cancel
          </Button>
          <LoaderButton
            working={working}
            variant="contained"
            color="primary"
            onClick={submitCard}
          >
            Save
          </LoaderButton>
        </Box>
      }
      fullScreen={false}
    />
  )
}

export default withStyles(styles)(UpdateCardInfoDialog)



// WEBPACK FOOTER //
// ./src/pages/Admin/pages/Settings/UpdateCardInfo/index.jsx